module.exports = __webpack_public_path__ + "img/jwwl.c04db1ce.jpg";